var React = require('react');

function RightArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 9H16.4486M16.4486 9L8.22432 0.775683M16.4486 9L8.22432 17.2243","stroke":"#414141","strokeWidth":"0.9"}));
}

RightArrowInline.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = RightArrowInline;

RightArrowInline.default = RightArrowInline;
